export default __webpack_public_path__ + "static/media/sound-off-circle.1a92fc69.svg";